module.exports = __webpack_public_path__ + "img/flashlight-icon.54f8b894.jpg";